<template>
	<modal
		size="small-medium"
		:hide-footer="true"
		@close="close">
		<template slot="header">
			<span v-if="!data">{{ $t('Add Promo') }}</span>
			<span v-else>{{ $t('Edit Promo') }}</span>
		</template>
		<template slot="body">
			<form @submit.prevent="save">
				<!-- name -->
				<div class="form-group">
					<label>{{ $t('Name') }}</label>
					<input type="text" name="name" class="form-control" v-model="name" required @keydown="textKeydown($event)">
				</div>
				<div :class="{'disabled': data}">
					<!-- Packages Ids -->
					<div class="form-group rundown-collab">
						<label class="typo__label">Packages</label>
							<div>
								<multiselect class="rundown-collab-input" v-model="packageIds" tag-placeholder="Add Packages"
								placeholder="Search or add a Package" label="name" track-by="id"
								:options="packagesParent" :multiple="true" :searchable="true" :show-labels="false">
								<span class="arrow-multiselect" slot="caret">
									<i class="material-icons pb-1 mt-2 ml-2 size-arrow">expand_more</i>
								</span>
								<span slot="noResult">Oops! No Packages found.</span>
								</multiselect>
							</div>
						</div>
					<!-- Dsicount -->
					<div class="d-flex">
						<div class="form-group col-lg-6 pl-0">
							<label>{{ $t('Discount') }}</label>
							<input v-if="discountType === 'percentage'" type="number" min=1 max=100 oninput="validity.valid||(value='');" name="type" class="form-control" v-model="discount" required>
							<input v-if="discountType === 'price'" type="number" min=1 oninput="validity.valid||(value='');" name="type" class="form-control" v-model="discount" required>
						</div>
						<!-- type Length -->
						<div class="form-group col-lg-7 pr-0 pb-0 mb-0">
							<label class="mb-0 pb-0">{{ $t('Type') }}</label>
							<div class="mt-0">
								<MdRadio class="type-length-package md-primary" v-model="discountType" value="percentage">{{$t('Percentage')}}</MdRadio>
								<MdRadio class="type-length-package md-primary" v-model="discountType" value="price">{{$t('Price')}}</MdRadio>
							</div>
						</div>
					</div>
					<!-- Duration -->
					<div class="d-flex">
						<!-- duration type -->
						<div class="form-group col-lg-6 pl-0 pb-0 mb-0">
							<label class="mb-2 pb-0">{{ $t('Type') }}</label>
							<select
								name="durationType"
								class="form-control"
								v-model="durationInMonths"
								required>
								<option
									v-for="durationType in durationTypeOptions"
									:key="durationType.value"
									:value="durationType.value">
									{{ durationType.name }}
								</option>
							</select>
						</div>
						<div class="form-group col-lg-6 pr-0">
							<label>{{ $t('Duration in Months') }}</label>
							<input type="number" min=0 oninput="validity.valid||(value='');" name="duration" class="form-control" v-model="duration" required v-if="durationInMonths === 'repeating'">
							<div class="form-control" v-else>-</div>
						</div>
					</div>
					<!-- max redemptions -->
					<div class="form-group">
						<label>{{ $t('Max Redemption ') }}({{ $t('\'0\' for unlimited') }})</label>
						<input min=0 oninput="validity.valid||(value='');" type="number" name="maxRedemption" class="form-control" v-model="maxRedemption" required>
					</div>
					<!-- Expired -->
					<div class="col-md-12 pl-0 pr-0">
						<div class="form-group">
							<label>{{ $t('Expired') }}</label>
							<flat-pickr
								class="date-event form-control"
								:config="configDateTimePicker"
								v-model="expired"
							/>
						</div>
					</div>
					<label v-if="data" class="text-small text-secondary">Edit can only be for the promo name</label>
				</div>
				<!-- Submit -->
				<button v-if="!data"
					:disabled="!isFormValid"
					type="submit"
					class="btn btn-submit btn-primary mt-3"
					:class="{ 'is-loading': isSaving }">
					{{ $t('Next') }}
				</button>
				<button v-else
					type="submit"
					class="btn btn-submit btn-primary mt-3"
					:class="{ 'is-loading': isSaving }">
					{{ $t('Update Promo') }}
				</button>
			</form>
		</template>
	</modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Modal from '@/components/Modal.vue';
import { getAxiosErrorMessage } from '@/lib/helper';
import promosApi from '@/api/promos';

export default {
	name: 'PromoForm',
	props: {
		data: {
			type: Object,
		},
		packagesParent: {
		},
	},
	components: {
		Modal,
		flatPickr,
		Multiselect,
	},
	data() {
		return {
			name: '',
			currency: '',
			discount: '',
			duration: '',
			expired: '',
			maxRedemption: 0,
			packageIds: '',
			discountType: 'percentage',
			durationInMonths: '',
			isSaving: false,
			configDateTimePicker: {
				enableTime: false,
				dateFormat: 'Y-m-d',
				minDate: 'today',
			},
			durationTypeOptions: [{
				name: 'Once',
				value: 'once',
			},
			{
				name: 'Repeating',
				value: 'repeating',
			},
			{
				name: 'Forever',
				value: 'forever',
			}],
			packages: [],
			isFetching: false,
		};
	},
	methods: {
		addTag() {
			this.rundowns.push();
			this.rundownIds.push();
		},
		save() {
			this.isSaving = true;
			const params = this.params;
			const callback = (response) => {
				const template = response.data;
				const message = response.message;
				this.$emit('saved', template);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add Promo',
					text: message,
				});
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Promo',
					text: message,
				});
				this.isSaving = false;
			};
			if (this.data) {
				promosApi.update(this.data.id, params, callback, errorCallback);
			} else {
				promosApi.create(params, callback, errorCallback);
			}
		},
		close() {
			this.$emit('close');
		},
		initData() {
			this.reset();
			if (this.data) {
				this.setData(this.data);
			}
		},
		reset() {
			this.name = '';
			this.currency = '';
			this.discount = '';
			this.duration = '';
			this.expired = '';
			this.maxRedemption = 0;
			this.packageIds = '';
			this.discountType = 'percentage';
			this.durationInMonths = 'repeating';
		},
		setData(data) {
			this.name = data.name;
			this.currency = data.currency;
			this.discount = data.discount;
			this.duration = data.duration_in_months;
			this.expired = data.expired_at;
			this.maxRedemption = data.max_redemptions;
			this.discountType = data.type;
			this.durationInMonths = data.duration;
			// set data package
			const packages = JSON.parse(data.package_ids);
			const packageObj = [];
			if (packages.length > 0) {
				for (let index = 0; index < packages.length; index++) {
					const packageElement = packages[index];
					packageObj.push(this.searchPackage(packageElement, this.packagesParent)); // eslint-disable-line no-param-reassign
				}
			}
			this.packageIds = packageObj;
		},
		searchPackage(id, packages) {
			for (let i = 0; i < packages.length; i++) {
				if (packages[i].id === id) {
					return packages[i];
				}
			}
			return packages;
		},
		textKeydown(e) {
			if (/[^A-Z0-9]/gi.test(e.key)) {
				e.preventDefault();
			}
		},
	},
	computed: {
		params() {
			const packages = [];
			for (let index = 0; index < this.packageIds.length; index++) {
				const id = this.packageIds[index].id;
				packages.push(id);
			}
			const params = {
				name: this.name,
				currency: 'usd',
				discount: this.discount,
				duration: this.durationInMonths,
				expired_at: this.expired,
				max_redemptions: this.maxRedemption,
				package_ids: JSON.stringify(packages),
				type: this.discountType,
				duration_in_months: this.duration,
			};
			return params;
		},
		isFormValid() {
			return (
				this.name !== ''
				&& this.discount !== ''
				&& this.expired !== ''
				&& this.maxRedemption !== ''
				&& this.discountType !== ''
				&& this.durationInMonths !== ''
			);
		},
	},
	created() {
		this.initData();
	},
	watch: {
		discountType() {
			if (this.discountType === 'percentage' && this.discount > 100) {
				// eslint-disable-next-line
				return this.discount = this.discount.slice(0, 2);
			}
			return this.discount;
		},
	},
};
</script>
